import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useUserLanguage } from '@/customHooks'
import { bedSizeMapper, capitalizeFirstLetter } from '@/helpers'
import { Unity } from '@/custom-types'

type PropertySimpleSelectionListProps = {
  selected: (unity: Unity | null) => void
  unities: Unity[]
}

const textsData = {
  en: {
    unity: {
      name: 'Name',
      bedSize: 'Bed Size',
      privateBath: 'Bath',
      airConditioner: 'A/C',
      fan: 'Fan'
    }
  },
  es: {
    unity: {
      name: 'Nombre',
      bedSize: 'Cama',
      privateBath: 'Baño',
      airConditioner: 'A/C',
      fan: 'Ventilador'
    }
  }
}

const StyledGridTable = styled.div`
  padding-top: ${({ theme }) => theme.spacing.lg} ;
  padding-bottom: ${({ theme }) => theme.spacing.lg} ;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 64px 2fr 2fr 1fr 1fr 1fr;
  row-gap: 10px;
  width: ${({ theme }) => theme.sizing.createFormsWidt.max};
  min-width: ${({ theme }) => theme.sizing.createFormsWidt.min};
`;

const StyledGridHeader = styled.div`
  display: contents;
  & > div {
    font-weight: bold;
    text-align: left;
    padding: 15px;
    border-top: 1px solid grey;
    border-bottom: 1px solid gray;
  }
`;

const StyledGridRow = styled.div`
  display: contents;

  & > div {
    padding: 15px;
    background-color: ${({ theme }) => theme.colors.background2};
    font-size: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    align-self: stretch;
    place-content: center;
    border-bottom: 1px solid lightgray;
  }
`;

export const UnitySimpleSelectionList = ({ selected, unities }: PropertySimpleSelectionListProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const [selectedUnityId, setSelectedUnityId] = useState<string | null>(null)

  useEffect(() => {
    if (!unities) return
    const unity = unities.find((unity) => selectedUnityId === unity.id)

    selected(unity ?? null)

  }, [selectedUnityId])

  return (
    <StyledGridTable>
      {/* Encabezado */}
      <StyledGridHeader>
        <div></div>
        <div>{texts.unity.name}</div>
        <div>{texts.unity.bedSize}</div>
        <div>{texts.unity.privateBath}</div>
        <div>{texts.unity.airConditioner}</div>
        <div>{texts.unity.fan}</div>
      </StyledGridHeader>

      {/* Filas dinámicas */}
      {unities?.map((data) => (
        <StyledGridRow key={data.id}>
          <div>
            <input
              type="radio"
              checked={selectedUnityId === data.id}
              onChange={() => setSelectedUnityId(data.id)}
            />
          </div>
          <div>{capitalizeFirstLetter(data.name)}</div>
          <div><p>{bedSizeMapper(data.bedSizeOption, userLanguage)}</p></div>
          <div><input type="checkbox" readOnly checked={data.privateBathroom} /></div>
          <div><input type="checkbox" readOnly checked={data.airConditioner} /></div>
          <div><input type="checkbox" readOnly checked={data.fan} /></div>
        </StyledGridRow>
      )) ?? null}
    </StyledGridTable>
  );
};
